import {CountAmenityType} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenity.type";
import createObjectFromArrayOfObjects from "@Array/createObjectFromArrayOfObjects";

/**
 * Creates an object where each key is amenity's key (easier access)
 */
export default function createObjectFromAmenityList(amenities: CountAmenityType[] | null = []): Record<string, CountAmenityType> {
    return (
        createObjectFromArrayOfObjects(
            amenities.map((amenity) => ({[amenity.key]: amenity}))
        ) ?? {}
    )
}